import { difficultyModalActionTypes } from '@/components/modals/difficulty/Constants';

import type { DifficultyModalActions, DifficultyModalState } from './types';

const initialState: DifficultyModalState = {
	open: false,
};

export default function difficultyModalReducer(
	state = initialState,
	action: DifficultyModalActions,
): DifficultyModalState {
	const { type, payload } = action;

	switch (type) {
		case difficultyModalActionTypes.TOGGLE_DIFFICULTY_MODAL:
			return {
				...state,
				open: payload.open,
			};
		default:
			return state;
	}
}
